import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import { trimTimestampFromDate } from '../../../../../lib/utils.es6';
import SkeletonWrapper from '../../../../../containers/NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { Tooltip } from '@mui/material';
import ButtonInc from '../../../../../shared-ui/ButtonInc';


const FailedEnteriesTable = (props) => {
  const classes = useStyle();

  const failedEnteries = props.failedEnteries || [];
  if(props.loading) return <SkeletonWrapper type="table" loading={true} />

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}  >
          <Grid container spacing={2} className={classes.claimdocswrapper}>
            <Grid item xs={12} sm={12} md={12}>

              <TableInc
                columns={[
                  { title: 'Batch Number', field: 'batch_number', render: rowData => rowData.batch_number || "N/A" },
                  { title: 'Created At', field: 'created_at', render: rowData => trimTimestampFromDate(rowData.created_at) || "N/A" },
                  { title: 'status', field: 'status' },
                  { title: 'index', field: 'index', },
                  { title: 'error message', field: 'message' },
                  {
                    title: 'Action', field: 'bucket_key', render: rowData => {
                      return <div className={classes.actionbtn}>
                        <Tooltip title="View Document">
                          <ButtonInc style={{ cursor: "pointer" }} ><a href={rowData.bucket_key} target='_blank' rel="noopener noreferrer" style={{color: 'white'}}> download original file</a> </ButtonInc>
                        </Tooltip>
                      </div>
                    }
                  },
                ]}
                data={query =>
                  new Promise((resolve, reject) => {
                      resolve({
                          data: [...failedEnteries.data],
                          page: failedEnteries.page - 1,
                          totalCount: failedEnteries.total,
                      });
                  })
              }
                options={{
                  showTitle: false,
                  pageSizeOptions: [1, 5, 10, 20, 50, 100],
                  pageSize: failedEnteries.page_size,

                }}

                onChangeRowsPerPage = {(pageSize) => {
                  console.log(pageSize, "pageSize")
                  props.onPageChange(failedEnteries.page, pageSize);
                }}

                onChangePage = {(page) => {
                  console.log(page, "page")
                  props.onPageChange(page + 1, failedEnteries.page_size);
                }
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default FailedEnteriesTable